export const checkIfEnum = <T>(value: T | string | undefined, enumType: T): boolean => {
  if (!value) {
    return false;
  }
  if (Object.values(enumType).some((enumValue) => enumValue === value)) {
    return true;
  }
  return false;
};
